import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import TextField from '@component/form/element/textfield';
import FormNotification from '@component/form/element/formnotification';

const PersonalInfo = ({
  fullName,
  email,
  password,
  passwordConfirm,
  onFieldChange,
  getErrorMessage,
  validate,
}) => {
  return (
    <React.Fragment>
      <TextField
        autoFocus
        label={I18n.t('form.account.label.full_name')}
        value={fullName}
        name="full_name"
        onChange={onFieldChange}
        valid={0}
      />
      <FormNotification message={getErrorMessage('full_name')} type="error" />
      <TextField
        type="email"
        label={I18n.t('form.account.label.email')}
        value={email}
        name="email"
        onChange={onFieldChange}
        valid={validate('email')}
      />
      <FormNotification message={getErrorMessage('email')} type="error" />
      <TextField
        value={password}
        label={I18n.t('form.account.label.password')}
        name="password"
        type="password"
        onChange={onFieldChange}
        valid={validate('password')}
        description={I18n.t('form.account.description.password')}
      />
      <FormNotification message={getErrorMessage('password')} type="error" />
      <TextField
        value={passwordConfirm}
        label={I18n.t('form.account.label.password_confirm')}
        name="password_confirm"
        type="password"
        onChange={onFieldChange}
        valid={validate('password_confirm')}
      />
      <FormNotification
        message={getErrorMessage('password_confirm')}
        type="error"
      />
    </React.Fragment>
  );
};

PersonalInfo.propTypes = {
  fullName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  passwordConfirm: PropTypes.string.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  getErrorMessage: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
};

export default PersonalInfo;
